/** A key typed into the cloud browser's page, as its input message carries it. */
export type Keystroke = { key: string; code: string; keyCode: number; text?: string };

const BACKSPACE: Keystroke = { key: 'Backspace', code: 'Backspace', keyCode: 8 };
const ENTER: Keystroke = { key: 'Enter', code: 'Enter', keyCode: 13, text: '\r' };

/**
 * The keys a touch keyboard's edit of a field stands for. Its keyboard sends no usable key
 * events (an Android keyboard composes words, autocorrects and says "Unidentified"): what
 * changed in the field is read instead, as backspaces over what was replaced, then what was
 * typed in its place.
 */
export function typedKeystrokes(before: string, after: string): Keystroke[] {
  const shared = Math.min(before.length, after.length);
  let prefix = 0;
  while (prefix < shared && before[prefix] === after[prefix]) prefix += 1;
  const removed = Array.from(before.slice(prefix)).length;
  const typed = Array.from(after.slice(prefix));
  return [
    ...Array.from({ length: removed }, () => BACKSPACE),
    ...typed.map((character) =>
      character === '\n' ? ENTER : { key: character, code: '', keyCode: 0, text: character },
    ),
  ];
}
